import {
    CLOSE_LOGIN_FORM,
    CLOSE_SIGNUP_FORM,
    DISABLE_VIDEO_GUIDE,
    DISABLE_VIDEO_LOCAL_GUIDE,
    REMOVE_QUICK_USER,
    REMOVE_REDIRECT_PATH,
    REMOVE_USER,
    RESET_ERROR,
    RESET_LOADER,
    RESET_REQUEST_MODAL,
    SET_ERROR,
    SET_LOADER,
    SET_REDIRECT_PATH,
    SET_VIRTUAL_DATA,
    SHOW_LOGIN_FORM,
    SHOW_SIGNUP_FORM,
    UPDATE_HELPER_SCREEN,
    UPDATE_QUICK_USER,
    UPDATE_REQUEST_MODAL,
    UPDATE_USER,
} from "../constants/contexConstant";

export const reducer = (state, action) => {
    switch (action.type) {
        case UPDATE_USER:
            return { ...state, user: action.payload };
        case UPDATE_QUICK_USER:
            return { ...state, quickUser: action.payload };

        case REMOVE_USER:
            return { ...state, user: null };
        case REMOVE_QUICK_USER:
            return { ...state, quickUser: null };

        case SHOW_LOGIN_FORM:
            if (state.signupForm) {
                return { ...state, loginForm: true, signupForm: false };
            }
            return { ...state, loginForm: true };
        case CLOSE_LOGIN_FORM:
            return { ...state, loginForm: false };

        case SHOW_SIGNUP_FORM:
            if (state.loginForm) {
                return { ...state, loginForm: false, signupForm: true };
            }
            return { ...state, signupForm: true };
        case CLOSE_SIGNUP_FORM:
            return { ...state, signupForm: false };

        case SET_REDIRECT_PATH:
            return { ...state, redirectPath: action.payload };
        case REMOVE_REDIRECT_PATH:
            return { ...state, redirectPath: null };

        case UPDATE_HELPER_SCREEN:
            return { ...state, isRegHelperScreenEnabled: false };
        case DISABLE_VIDEO_GUIDE:
            return {
                ...state,
                videoGuide: true,
            };
        case DISABLE_VIDEO_LOCAL_GUIDE:
            localStorage.setItem("videoGuide", "true");
            return {
                ...state,
                videoGuide: true,
            };
        case SET_ERROR:
            return { ...state, error: action.payload };
        case RESET_ERROR:
            return { ...state, error: null };
        case SET_LOADER:
            return { ...state, loading: true };
        case RESET_LOADER:
            return { ...state, loading: false };
        case SET_VIRTUAL_DATA:
            return { ...state, virtualData: action.payload };
        case UPDATE_REQUEST_MODAL:
            return { ...state, requestCallback: true };
        case RESET_REQUEST_MODAL:
            return { ...state, requestCallback: false };
        default:
            return state;
    }
};
